
export enum DealInsightTab { // deal tabs
  ALL = 'ALL',
  ON_TARGET = 'ON_TARGET',
  SLIPPING_AWAY = 'SLIPPING_AWAY',
  AT_RISK = 'AT_RISK',
}

export enum DealInsightTimelineMode { // timeline tabs
  BOTH = 'both',
  ACTIVITY = 'activity',
  PREDICTION = 'prediction',
}

export enum ActivityTypes { // activity types
  CALL = 'CALL',
  EMAIL = 'EMAIL',
  NOTE = 'NOTE',
  TASK = 'TASK',
  MEETING = 'MEETING',
  STAGE_CHANGE = 'STAGE_CHANGE',
  PAPERFLITE='PAPERFLITE'
}

export type SortOrder = 'asc' | 'desc';

// deal summary
export interface DealSummary {
  totalActiveDeals: number;
  valueByRevenue: number;
  thisMonthActivityChangePct: number;
  avgDealSize: number;
  dealsAtRisk: number;
}

// filter options
export interface Stages {
  externalId: string;
  label: string;
}

export interface Pipeline {
  externalId: string;
  label: string;
  stages: Stages[];
}

export interface Owner {
  externalId: string;
  name: string;
}

export interface FilterOptions {
  pipelines: Pipeline[];
  owners: Owner[];
}

// list of deals
export interface DealsRequestPayload {
  page: number;
  size: number;
  search?: string;
  riskStatus?: string;
  pipelineExternalId?: string;
  stageExternalId?: string;
  ownerExternalId?: string;
  minAmount?: number | any;
  maxAmount?: number | any;
  closeDateFrom?: number | any;
  closeDateTo?: number | any;
  lastActivityFrom?: number | any;
  lastActivityTo?: number | any;
  createdDateFrom?: number | any;
  createdDateTo?: number | any;
  hasDealRoom?: boolean | any;
}

export interface Deal {
  id: string;
  dealName: string;
  amount: number | null;
  pipelineExternalId: string;
  stageExternalId: string;
  stageLabel: string;
  closeDate: number | null;
  ownerExternalId: string;
  ownerName: string;
  lastActivity: number | null;
  predictionScore: number | null;
  riskStatus: string;
  predictionTrend?: 'up' | 'down';
}

export interface ListOfDeals {
  deals: Deal[];
  totalCount: number;
  page: number;
  totalPages: number;
  size: number;
}

// activities
export interface ActivitiesRequestPayload {
  page: number;
  size: number;
  dealExternalId?: string;
  activityType?: string;
}

export interface Activities {
  id: string;
  activityType: string;
  title: string;
  subject: string;
  body: string;
  occurredAt: number | null;
  direction: string;
  durationMs: number | null;
  status: string;
  dealIds: string[];
  dealValue: number | null;
  ownerExternalId: string;
  ownerName: string;
  dealDetails?: {
    id: string;
    name: number;
  }
}

export interface ListOfActivities {
  activities: Activities[];
  totalCount: number;
  page: number;
  totalPages: number;
  size: number;
}

// timeline
export interface DealTimelineRequestPayload {
  dealExternalId: string;
}

export interface TimelineActivity {
  type: string;
  count: number;
  subject: string[];
  activityIds: string[];
}

export interface Timeline {
  date: string;
  activities: TimelineActivity[];
}

export interface DealTimeLineResponse {
  timelines: Timeline[];
}

// deal details

export interface DealDetailsRequestPayload {
  dealId: string;
}

export interface Contact {
  externalId: string;
  fullName: string;
  title: string;
  lastActivityDate: number | null;
}

export interface DealDetails {
  id: string;
  amount: number | null;
  stageExternalId: string;
  stageLabel: string;
  closeDate: number | null;
  createDate: number | null;
  lastActivityDate: number | null;
  companyName: string;
  ownerExternalId: string;
  ownerName: string;
  meetingCount: number;
  emailSentCount: number;
  emailReceivedCount: number;
  contacts: Contact[];
  externalId: string | null;
  dealName: string | null;
  healthScore?: number;
}

export interface NudgeItem {
  priority?: number;
  header: string;
  nudgeAction?: string;
  actionPlan?: string;
}
